exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gz-body printos-header{display:none}.gz-body.show printos-header{display:inherit}.gz-body ui-view{position:absolute}.gz-body md-content{background-color:#fff}.gz-body .gz-app-content{overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/body-wrap/body-wrap.scss
// module id = 99
// module chunks = 0